<template>
  <div>error<br>
  您不在客莱宝的使用名单中
  </div>
</template>
<script>
export default {
  name: 'Error',
  data(){
    return {
      
    }
  }

}
</script>